import React, { useState } from 'react';
import '../App.css';
import axios from "axios";

//import axios from "axios";
import { Dropdown, Modal } from 'react-bootstrap';
import Mail_richiesta_dati from "./Alunno_x1_mail_dati";
import Alunno_Form_Base from "./Alunno_form_base";
import { AiOutlineMenuFold } from 'react-icons/ai';
import Sposta_alunno_nel_cestino  from "./Alunno_x5_cancellazione";
import Aggiungi_documentazione_attore from "../Funzioni_comuni_pdf_upload.jsx"; 
import Preparazione_documenti_alunno from "./Alunno_x6_preparazione_documenti.jsx";

const Nuovo_Alunno_Edit = (props) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [end_Date, set_End_Date] = useState(new Date());

    function cambia_opzione_sposta_classi () {
        props.SET_opzione_sposta_alunno(current => !current)
    }

    return (
        <div class="d-flex flex-row-reverse">
               {/* idroslab  primo dropdown*/}
     
            <Dropdown>
                <Dropdown.Toggle variant="Light" id="dropdown-basic">
                    Menu  <AiOutlineMenuFold />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Mail_richiesta_dati alunno={props.alunno} tutor= {props.tutor} variab_aggiorna={props.variab_aggiorna} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <div class="dropdown-divider"></div>

                    <Dropdown.Item onClick={handleShow} >Edit alunno</Dropdown.Item>

                    <Sposta_alunno_nel_cestino alunno={props.alunno} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <Dropdown.Item onClick={cambia_opzione_sposta_classi} >Sposta in altra classe</Dropdown.Item>
              
                    <div class="dropdown-divider"></div>

                    <Preparazione_documenti_alunno tutor= {props.tutor} alunno={props.alunno}/>

                    {/*------------------ AGGIORNARE MONGO QRCODE ---------------------------*/}   

                    <Aggiungi_documentazione_attore attore_tipo ={'alunno'} tipologia_documento={'formazione_A'} tutor={props.tutor} attore={props.alunno} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <Aggiungi_documentazione_attore attore_tipo ={'alunno'} tipologia_documento={'formazione_B'} tutor={props.tutor} attore={props.alunno} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <Aggiungi_documentazione_attore attore_tipo ={'alunno'} tipologia_documento={'formazione_C'} tutor={props.tutor} attore={props.alunno} SET_variab_aggiorna={props.SET_variab_aggiorna} />
               
                </Dropdown.Menu>
            </Dropdown>

            <Modal
                show={show}
                size="xl"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >

            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">

                </Modal.Title>
            </Modal.Header>
               <Modal.Body>
                        <Alunno_Form_Base id={props.alunno._id} setShow={setShow} />
                    </Modal.Body>
               
            </Modal>
        </div>
    )
}
export default Nuovo_Alunno_Edit;
